import { render, staticRenderFns } from "./TemplateSection.vue?vue&type=template&id=1b782afe&"
import script from "./TemplateSection.vue?vue&type=script&lang=js&"
export * from "./TemplateSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports